import { useEffect, useState } from 'preact/hooks'
import { useAppContext } from '../contexts/AppContext'
import { checkCompletionKeywords } from '../services/completionKeywordsService'
import { ON_ACTION_CARD_SAVE_EVENT } from '../constants'

function useCompletionKeywordsState() {
  const [completionKeywordsState, setCompletionKeywordsState] = useState(false)
  const { actionCardService, completionKeywords } = useAppContext()

  useEffect(() => {
    adjustCompletionKeywordsState()

    window.addEventListener(ON_ACTION_CARD_SAVE_EVENT, adjustCompletionKeywordsState)
    return () => {
      window.removeEventListener(ON_ACTION_CARD_SAVE_EVENT, adjustCompletionKeywordsState)
    }
  }, [actionCardService])

  function adjustCompletionKeywordsState() {
    const keywords = actionCardService.getActionCardModel()?.getActiveTagNames()
    setCompletionKeywordsState(checkCompletionKeywords(keywords, completionKeywords))
  }

  return completionKeywordsState
}

export default useCompletionKeywordsState
